import { render, staticRenderFns } from "./AppFamilyInformation.vue?vue&type=template&id=7be58b9d&"
import script from "./AppFamilyInformation.vue?vue&type=script&lang=js&"
export * from "./AppFamilyInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports